App.Models.ReviewRequest = BackboneEx.Model.Silent.extend({
  url: function () {
    var base = '/venue/' + App.getVenueId() + '/review-request.json';
    return App.Api.wsUrl(base);
  },
});
